<template>
    <div class="total-container">
        <div class="line"></div>
        <div class="text-large">总收入：{{data.totalInconme? data.totalInconme: 0}}元</div>
        <!-- <div class="icon-text-item">
            <img src="../assets/images/icon_pay_w.png">
            微信 {{data.wxPay}}元
        </div>
        <div class="icon-text-item">
            <img src="../assets/images/icon_pay_a.png">
            支付宝 {{data.aliPay}}元
        </div>
        <div class="icon-text-item">
            <img src="../assets/images/icon_pay_r.png">
            园区支付 {{data.rangePay}}元
        </div> -->
        <div class="text-large" style="margin-left:119px;">总支出：{{data.totalPay?data.totalPay: 0}}元</div>
        <div class="icon-text-item">
            <img src="../assets/images/icon_pay_w.png">
            微信 {{data.wxPay || 0}}元
        </div>
        <div class="icon-text-item">
            <img src="../assets/images/icon_pay_a.png">
            支付宝 {{data.aliPay || 0}}元
        </div>
        <div class="icon-text-item">
            <img src="../assets/images/icon_pay_r.png">
            园区支付 {{data.rangePay || 0}}元
        </div>
        <div class="icon-text-item">
            优惠券 {{data.couponPay || 0}}元
        </div>
        <div class="text-large" style="margin-left:60px;">笔数：{{data.totalCount || 0}}笔</div>
    </div>
</template>

<script>
    export default {
        props:{
            data:{
                type: Object,
                default:{}
            }
        },
        data() {
            return {
                key: 'value'
            }
        },
    }
</script>

<style lang="scss" scoped>
.total-container{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    height: 40px;
    background: rgba($color: #30CE7E, $alpha: 0.2);
    min-width: 600px;
    .line{
        width: 3px;
        height: 100%;
        background: #30CE7E;
        margin-right: 20px;
    }
    .text-large{
        font-size: 14px;
        color: #323232;
    }
    .icon-text-item{
        margin-left: 32px;
          display: flex;
    flex-direction: row;
    justify-content: flex-start;
        font-size: 12px;
        color: #8A989F;
        >img{
            width: 18px;
            height: 18px;
            margin-right: 6px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/Total.vue